import axiosClient from '@/services/shared/api/axios-client';
import { CreateLevelTestGroupInput, LevelTestGroup, UpdateLevelTestGroupInput, LevelTestGroupListResponse } from './levelTestGroups.interfaces';

export const apiGetLevelTestGroups = async (filters?: {
  level?: number;
  search?: string;
  page?: number;
  limit?: number;
}): Promise<LevelTestGroupListResponse> => {
  const params = new URLSearchParams();
  if (filters?.level) params.append('level', filters.level.toString());
  if (filters?.search) params.append('search', filters.search);
  if (filters?.page) params.append('page', filters.page.toString());
  if (filters?.limit) params.append('limit', filters.limit.toString());

  const response = await axiosClient.get(`/admin/level-test-groups?${params.toString()}`);
  const { items, total, page, limit } = response.data;

  return {
    items,
    total,
    page,
    limit
  };
};

export const apiGetLevelTestGroup = async (id: string): Promise<LevelTestGroup> => {
  const response = await axiosClient.get(`/admin/level-test-groups/${id}`);
  return response.data;
};

export const apiCreateLevelTestGroup = async (data: CreateLevelTestGroupInput): Promise<string> => {
  const response = await axiosClient.post('/admin/level-test-groups', data);
  return response.data.id;
};

export const apiUpdateLevelTestGroup = async (id: string, data: UpdateLevelTestGroupInput): Promise<void> => {
  await axiosClient.put(`/admin/level-test-groups/${id}`, data);
};

export const apiDeleteLevelTestGroup = async (id: string): Promise<void> => {
  await axiosClient.delete(`/admin/level-test-groups/${id}`);
};
